(function () {
  function addToCart(items) {
    console.log('[cart-drawer] adding items:', items);
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      console.log('[cart-drawer] /cart/add.js status:', r.status, 'content-type:', r.headers.get('content-type'));
      if (!r.ok) {
        return r.text().then(function (txt) {
          var msg = 'Cart add failed';
          try { var j = JSON.parse(txt); msg = j.description || j.message || msg; } catch (e) {}
          console.error('[cart-drawer] add error body:', txt.slice(0, 300));
          var err = new Error(msg);
          err.status = r.status;
          throw err;
        });
      }
      return r.json().then(function (data) {
        console.log('[cart-drawer] add OK, response:', data);
        return data;
      });
    });
  }

  function refreshCartDrawer() {
    // Impulse's CartForm listens globally for 'cart:build' and on each fire
    // calls its buildCart() — which fetches /cart?view=ajax, swaps the
    // .cart__items markup, updates subtotal/count, toggles is-empty, AND
    // re-binds QtySelector instances on each line item. By dispatching the
    // event we delegate the entire refresh to the theme so quantity +/-
    // buttons keep working.
    document.dispatchEvent(new CustomEvent('cart:build'));
    return new Promise(function (resolve) {
      setTimeout(function () {
        var drawer = document.querySelector('#CartDrawer');
        var lineCount = drawer ? drawer.querySelectorAll('.cart__item').length : 0;
        console.log('[cart-drawer] cart:build done, line items:', lineCount);
        resolve(true);
      }, 900);
    });
  }

  function updateCartCount() { return Promise.resolve(); }

  function openDrawer() {
    // Cache the Drawers instance so multiple Add-bundle clicks do not stack
    // duplicate event listeners on the cart-toggle and close buttons.
    if (!window.__cartDrawerInstance && window.theme && typeof window.theme.Drawers === 'function') {
      try {
        window.__cartDrawerInstance = new window.theme.Drawers('CartDrawer', 'cart');
      } catch (e) { window.__cartDrawerInstance = null; }
    }
    var inst = window.__cartDrawerInstance;
    if (inst && typeof inst.open === 'function') {
      if (!inst.isOpen) inst.open();
      return true;
    }
    var toggle = document.querySelector('.js-drawer-open-cart');
    if (toggle) {
      var evt = new MouseEvent('click', { bubbles: true, cancelable: true });
      var ok = toggle.dispatchEvent(evt);
      if (ok && evt.defaultPrevented) return true;
    }
    return false;
  }

  function updateHeaderBadge() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-link__bubble-num, [data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        var bubble = document.querySelector('.cart-link__bubble');
        if (bubble) bubble.classList.toggle('cart-link__bubble--visible', cart.item_count > 0);
        return cart;
      })
      .catch(function () { return null; });
  }

  // Items in this list are never duplicated in cart (e.g., free-gift Ascend).
  // The site-wide BxGy discount only makes ONE Ascend free; adding more would
  // charge the customer for the extras.
  var DEDUP_VARIANT_IDS = [50787318432059]; // Ascend White

  function dedupItemsAgainstCart(items) {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var existingIds = (cart.items || []).map(function (i) { return i.variant_id; });
        return items.filter(function (it) {
          if (DEDUP_VARIANT_IDS.indexOf(it.id) === -1) return true;
          // Drop dedup-protected items that are already in cart.
          return existingIds.indexOf(it.id) === -1;
        });
      })
      .catch(function () { return items; });
  }

  function safe(p) {
    return Promise.resolve(p).catch(function (e) { console.warn('[cart-drawer] non-fatal:', e); return null; });
  }

  window.__bundleAddAndOpenDrawer = function (items, btn, originalLabel) {
    btn.disabled = true;
    btn.textContent = 'Adding...';

    dedupItemsAgainstCart(items)
      .then(function (filtered) {
        if (!filtered.length) {
          // Everything in the bundle is already in the cart (only happens when
          // the bundle has only the dedup-protected item, but stay safe).
          console.log('[cart-drawer] all items already in cart');
          return Promise.resolve();
        }
        return addToCart(filtered);
      })
      .then(function () {
        return Promise.all([safe(refreshCartDrawer()), safe(updateHeaderBadge())]);
      })
      .then(function () {
        btn.disabled = false;
        btn.textContent = originalLabel;
        var opened = openDrawer();
        if (!opened) {
          btn.textContent = 'Added. View cart ›';
          btn.onclick = function () { window.location.href = '/cart'; };
        }
      })
      .catch(function (err) {
        console.error('[cart-drawer] add failed:', err);
        btn.disabled = false;
        btn.textContent = 'Could not add: ' + (err.message || 'try again');
        setTimeout(function () { btn.textContent = originalLabel; }, 4000);
      });
  };
})();

(function () {
  function bindCard(card) {
    if (card.dataset.singleBound === '1') return;
    card.dataset.singleBound = '1';

    var sel = card.querySelector('[data-single-select]');
    var priceEl = card.querySelector('[data-single-price]');
    var btn = card.querySelector('[data-single-add]');
    if (!sel || !btn) return;

    sel.addEventListener('change', function () {
      var opt = sel.options[sel.selectedIndex];
      if (priceEl && opt && opt.dataset.price) priceEl.textContent = opt.dataset.price;
    });

    btn.addEventListener('click', function () {
      var variantId = parseInt(sel.value, 10);
      var ascendId = parseInt(btn.dataset.ascendId, 10);
      if (!variantId) return;
      var items = [{ id: variantId, quantity: 1 }];
      if (ascendId) items.push({ id: ascendId, quantity: 1 });
      var original = btn.textContent;
      window.__bundleAddAndOpenDrawer(items, btn, original);
    });
  }

  function init() {
    document.querySelectorAll('[data-single-card]').forEach(bindCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
